var getActiveRouteDescriptor = function getActiveRouteDescriptor(props) {
  var navigation = props.navigation,
    descriptors = props.descriptors;
  var activeKey = navigation.state.routes[navigation.state.index].key;
  return descriptors[activeKey];
};
export default getActiveRouteDescriptor;